"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontABS = exports.fontMargo = exports.fontObjectiv = exports.FontWeightArray = exports.FontWeightValue = exports.FontFamilyArray = exports.FontFamilyValue = void 0;
var FontFamilyValue = {
  primary: 'Objektiv',
  secondary: 'Margo Script',
  tertiary: 'ABScript'
};
exports.FontFamilyValue = FontFamilyValue;
var FontFamilyArray = ['primary', 'secondary', 'tertiary'];
exports.FontFamilyArray = FontFamilyArray;
var FontWeightValue = {
  thin: 100,
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700,
  xbold: 800,
  black: 900
};
exports.FontWeightValue = FontWeightValue;
var FontWeightArray = ['thin', 'light', 'normal', 'medium', 'bold', 'xbold', 'black'];
exports.FontWeightArray = FontWeightArray;
var fontObjectiv = {
  light: 'ObjektivMk2-Light',
  regular: 'ObjektivMk2-Regular',
  medium: 'ObjektivMk2-Medium',
  bold: 'ObjektivMk2-Bold'
};
exports.fontObjectiv = fontObjectiv;
var fontMargo = {
  regular: 'MargoScript-Regular'
};
exports.fontMargo = fontMargo;
var fontABS = {
  light: 'ABScript-Light',
  regular: 'ABScript-Regular',
  bold: 'ABScript-Bold'
};
exports.fontABS = fontABS;